import React, { Component } from "react";

class LoadingScreen extends Component {
  render() {
    return (
      <div className="w-100 h-100 justify-content-center align-items-center">
        <h1>LOADING...</h1>
      </div>
    );
  }
}

export default LoadingScreen;
